import * as PartnerApi from "features/Partner/api/PartnerApi"

import { isNotEmpty, isDefined } from "utils/validation"
import { jsonHash } from "utils/hash"
import { sortByProperty } from "utils/functions"
import dateService from "services/date"
import {
	HORS_AM_GENDER,
	AM_GENDER,
	genderMFCList,
	MFC_OPERATOR,
	BC_OPERATOR,
	MC_OPERATOR,
	MFC_RETAIL_GENDER,
	ACTIVE_OPERATOR_STATUS,
} from "utils/constants"

export const fetchBOPartner = async (
	slug,
	isAdminOCode,
	setJsonHashEntityData,
	setJsonHashOperatorData
) => {
	let loadedPartner
	if (slug) {
		const { res, getError } = await PartnerApi.getPartner(slug)
		if (getError()) throw getError()
		loadedPartner = res
	}

	let isBicycode = false
	let isMoustache = false
	let isMFC = false
	let mfc_client_number = ""
	let payment_type = 1
	let bc_bic
	let bc_iban
	let bc_bank_name
	let bc_effective_date
	let bc_rum
	let invoicing_agent_mail
	let invoicing_agent_firstname
	let invoicing_agent_lastname
	let gender_mfc = genderMFCList.find((oneGenderMFC) => oneGenderMFC.id_api === MFC_RETAIL_GENDER)
	let isFub = false
	let bc_account_id
	let mfc_account_id
	let mfc_is_fleet
	let bc_is_fleet

	const dataOperatorsToHash = []
	let i = 0
	for (i = 0; i < loadedPartner?.data_operators.length; i++) {
		const oneOperator = loadedPartner?.data_operators[i]
		if (oneOperator.operator === BC_OPERATOR) {
			isBicycode = oneOperator.status === ACTIVE_OPERATOR_STATUS
			isFub = oneOperator?.entity_data?.is_member_fub?.toString() || "false"
			payment_type = isNotEmpty(oneOperator?.entity_data?.iban) ? 0 : 1
			bc_bic = oneOperator?.entity_data?.bic || ""
			bc_iban = oneOperator?.entity_data?.iban || ""
			bc_bank_name = oneOperator?.entity_data?.bank_name || ""
			bc_effective_date = oneOperator?.entity_data?.effective_date || ""
			bc_rum = oneOperator?.entity_data?.rum || ""
			invoicing_agent_mail = oneOperator?.entity_data?.invoicing_agent_mail || ""
			invoicing_agent_firstname = oneOperator?.entity_data?.invoicing_agent_firstname || ""
			invoicing_agent_lastname = oneOperator?.entity_data?.invoicing_agent_lastname || ""
			bc_account_id = oneOperator?.entity_data?.account_id || ""
			bc_is_fleet = oneOperator?.entity_data?.is_fleet ?? undefined
		}

		if (oneOperator.operator === MFC_OPERATOR) {
			isMFC = oneOperator.status === ACTIVE_OPERATOR_STATUS
			mfc_client_number = oneOperator?.entity_data?.operator_store_id || ""
			gender_mfc = genderMFCList.find(
				(oneGenderMFC) => oneGenderMFC.id_api === oneOperator?.entity_data?.operator_gender
			)
			mfc_account_id = oneOperator?.entity_data?.account_id || ""
			mfc_is_fleet = oneOperator?.entity_data?.is_fleet ?? undefined
		}

		if (oneOperator.operator === MC_OPERATOR) {
			isMoustache = oneOperator.status === ACTIVE_OPERATOR_STATUS
		}

		const oneOperatorToHash = {}
		oneOperatorToHash.entity_data = oneOperator.entity_data
		oneOperatorToHash.status = oneOperator.status
		oneOperatorToHash.operator = oneOperator.operator
		dataOperatorsToHash.push(oneOperatorToHash)
	}

	const fetchedPartner = {
		entity_id: loadedPartner?.entity_id || "",
		status: loadedPartner?.status || "",
		// fbo - api
		row_hash: loadedPartner?.row_hash || "",
		manager: loadedPartner?.user_referent || {},
		data_operators: loadedPartner?.data_operators, // pour le sendmail

		isBicycode: isBicycode,
		isMoustache: isMoustache,
		is_activate_by_G8: loadedPartner?.futurosoft?.is_activate_by_G8 || false,
		payment_type: payment_type,
		bc_bic: bc_bic,
		bc_iban: bc_iban,
		bc_bank_name: bc_bank_name,
		bc_effective_date: bc_effective_date,
		bc_rum: bc_rum,
		invoicing_agent_mail: invoicing_agent_mail,
		invoicing_agent_firstname: invoicing_agent_firstname,
		invoicing_agent_lastname: invoicing_agent_lastname,
		isMFC: isMFC,
		isFub: isFub,
		bc_account_id: bc_account_id,
		mfc_account_id: mfc_account_id,
		bc_is_fleet: bc_is_fleet,
		mfc_is_fleet: mfc_is_fleet,
		// Permissions
		// isBicycode: !!(loadedPartner?.entity_data?.entity_permission?.operateurs.find(oneOperator => oneOperator === 'BC') === 'BC') || "",
		// isMFC: !!(loadedPartner?.entity_data?.entity_permission?.operateurs.find(oneOperator => oneOperator === 'MF') === 'MF') || "",
		gender: loadedPartner?.gender?.toString ? loadedPartner?.gender : isAdminOCode ? 0 : "",
		gender_mfc: gender_mfc?.value || 0,
		mfc_client_number: mfc_client_number,
		declarator_number: loadedPartner?.entity_id || "",
		bicycode_state: loadedPartner?.create_date
			? dateService.formatDate(loadedPartner?.create_date, "dd/MM/y")
			: "",

		// Structure
		raison_sociale: loadedPartner?.entity_data?.raison_sociale || "",
		code_ape: loadedPartner?.entity_data?.code_ape || "",
		nom_commercial: loadedPartner?.entity_data?.nom_commercial || "",
		siret: loadedPartner?.entity_data?.siret || "",
		tva_intra: loadedPartner?.entity_data?.tva_intra || "",
		structureChainName: loadedPartner?.entity_data?.est_une_chaine
			? loadedPartner?.entity_data?.code_chaine
			: "",
		isFranchise: loadedPartner?.entity_data?.est_une_chaine?.toString() || "false",
		isMaker: loadedPartner?.entity_data?.est_un_fabricant?.toString() || "false",
		//isFub: "true",
		numero_et_voie: loadedPartner?.entity_data?.adresse?.numero_et_voie || "",
		code_postal: loadedPartner?.entity_data?.adresse?.code_postal || "",
		ville: loadedPartner?.entity_data?.adresse?.ville || "",
		pays: loadedPartner?.entity_data?.adresse?.pays || "",
		code_insee: loadedPartner?.entity_data?.adresse?.code_insee || "00000",
		telephone_2: loadedPartner?.entity_data?.telephone_2 || "",
		latitude: loadedPartner?.entity_data?.latitude,
		longitude: loadedPartner?.entity_data?.longitude,
		site_web: loadedPartner?.entity_data?.site_web || "",

		// Specificity for AM and HAM
		...(() => {
			// Alsace Moselle
			if (loadedPartner?.gender === AM_GENDER) {
				// we create next a new date like new Date("03/12/2021")
				const str = loadedPartner?.entity_data?.siret
				return {
					registre_date:
						str?.substring(2, 4) +
						"/" +
						str?.substring(0, 2) +
						"/" +
						str?.substring(4, 8),
					registre_volume: str?.substring(8, 11),
					registre_folio: str?.substring(11, 14),
				}
			} else {
				return {
					registre_date: new Date(),
					registre_volume: "",
					registre_folio: "",
				}
			}
		})(),
		rna:
			loadedPartner?.gender === HORS_AM_GENDER
				? loadedPartner?.entity_data?.siret.replace("WWWWW", "")
				: "",

		// Manager
		nom_representant_legal: loadedPartner?.entity_data?.nom_representant_legal || "",
		prenom_representant_legal: loadedPartner?.entity_data?.prenom_representant_legal || "",
		mail: loadedPartner?.entity_data?.mail || "",
		telephone_1: loadedPartner?.entity_data?.telephone_1 || "",

		// Documents
		rib:
			loadedPartner?.entity_data?.documents?.find((item) => item?.media_gender === "RIB") ||
			"",
		sepa:
			loadedPartner?.entity_data?.documents?.find((item) => item?.media_gender === "SEPA") ||
			"",
		joaffe:
			loadedPartner?.entity_data?.documents?.find(
				(item) => item?.media_gender === "JOAFFE"
			) || "",
		urssaf:
			loadedPartner?.entity_data?.documents?.find(
				(item) => item?.media_gender === "URSSAF"
			) || "",
		attestation_asso:
			loadedPartner?.entity_data?.documents?.find(
				(item) => item?.media_gender === "Attestation"
			) || "",
		kbis: loadedPartner?.entity_data?.documents?.find((item) => item?.media_gender === "KBIS"),
		frontCard:
			loadedPartner?.entity_data?.documents?.find(
				(item) => item?.media_gender === "carte_identite_recto"
			) || "",
		backCard:
			loadedPartner?.entity_data?.documents?.find(
				(item) => item?.media_gender === "carte_identite_verso"
			) || "",
		workingHours: loadedPartner?.entity_data?.horaires_ouverture,

		// Wallet
		wallet_id: loadedPartner?.entity_data?.wallet_id || "",
		// if bike collection import feature functionality is authorized for the partner.
		import_allowed: loadedPartner?.entity_data?.import_allowed || false,
		est_bicytrust: loadedPartner?.entity_data?.est_bicytrust || false,
	}
	if (loadedPartner?.entity_data?.entity_permission) {
		delete loadedPartner.entity_data.entity_permission
	}
	if (isDefined(loadedPartner?.entity_data)) {
		setJsonHashEntityData(jsonHash(loadedPartner.entity_data))
	}
	if (isDefined(dataOperatorsToHash)) {
		setJsonHashOperatorData(jsonHash(dataOperatorsToHash.sort(sortByProperty("operator"))))
	}

	return fetchedPartner
}
